import HeroSlider from '@components/HeroSlider/HeroSlider';
import CategoryListing from '@components/CategoryListing/CategoryListing';
import TestimonialsSlider from '@components/TestimonialsSlider/TestimonialsSlider';

HeroSlider();
CategoryListing();
TestimonialsSlider();
